/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { UserDto } from '../models/user-dto';
import { usersControllerFindUserByEmailOrPhoneNumber } from '../fn/users/users-controller-find-user-by-email-or-phone-number';
import { UsersControllerFindUserByEmailOrPhoneNumber$Params } from '../fn/users/users-controller-find-user-by-email-or-phone-number';
import { usersControllerGetCurrentUser } from '../fn/users/users-controller-get-current-user';
import { UsersControllerGetCurrentUser$Params } from '../fn/users/users-controller-get-current-user';
import { usersControllerGetUserById } from '../fn/users/users-controller-get-user-by-id';
import { UsersControllerGetUserById$Params } from '../fn/users/users-controller-get-user-by-id';
import { usersControllerHardDeleteUser } from '../fn/users/users-controller-hard-delete-user';
import { UsersControllerHardDeleteUser$Params } from '../fn/users/users-controller-hard-delete-user';
import { usersControllerUpdateProfile } from '../fn/users/users-controller-update-profile';
import { UsersControllerUpdateProfile$Params } from '../fn/users/users-controller-update-profile';

@Injectable({ providedIn: 'root' })
export class PlatformUsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersControllerFindUserByEmailOrPhoneNumber()` */
  static readonly UsersControllerFindUserByEmailOrPhoneNumberPath = '/api/v1/users/find-by-email-or-phone-number';

  /**
   * Find user by email or phone number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindUserByEmailOrPhoneNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindUserByEmailOrPhoneNumber$Response(params: UsersControllerFindUserByEmailOrPhoneNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = usersControllerFindUserByEmailOrPhoneNumber(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Find user by email or phone number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindUserByEmailOrPhoneNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindUserByEmailOrPhoneNumber(params: UsersControllerFindUserByEmailOrPhoneNumber$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.usersControllerFindUserByEmailOrPhoneNumber$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `usersControllerGetCurrentUser()` */
  static readonly UsersControllerGetCurrentUserPath = '/api/v1/users/get-current-user';

  /**
   * Get current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerGetCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerGetCurrentUser$Response(params?: UsersControllerGetCurrentUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = usersControllerGetCurrentUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerGetCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerGetCurrentUser(params?: UsersControllerGetCurrentUser$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.usersControllerGetCurrentUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `usersControllerGetUserById()` */
  static readonly UsersControllerGetUserByIdPath = '/api/v1/users/{userId}';

  /**
   * Get user by id.
   *
   * SuperAdmin can fetch any user. Store Admin can fetch themselves or a user who is a host of a session in the store from terrific-store-id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerGetUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerGetUserById$Response(params: UsersControllerGetUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = usersControllerGetUserById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get user by id.
   *
   * SuperAdmin can fetch any user. Store Admin can fetch themselves or a user who is a host of a session in the store from terrific-store-id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerGetUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerGetUserById(params: UsersControllerGetUserById$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.usersControllerGetUserById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `usersControllerHardDeleteUser()` */
  static readonly UsersControllerHardDeleteUserPath = '/api/v1/users/{userId}';

  /**
   * Hard deletes the user from Firestore and user Authentication.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerHardDeleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerHardDeleteUser$Response(params: UsersControllerHardDeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = usersControllerHardDeleteUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Hard deletes the user from Firestore and user Authentication.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerHardDeleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerHardDeleteUser(params: UsersControllerHardDeleteUser$Params, context?: HttpContext): Observable<void> {
    const resp = this.usersControllerHardDeleteUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersControllerUpdateProfile()` */
  static readonly UsersControllerUpdateProfilePath = '/api/v1/users/me';

  /**
   * Update current user profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerUpdateProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerUpdateProfile$Response(params: UsersControllerUpdateProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = usersControllerUpdateProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update current user profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerUpdateProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerUpdateProfile(params: UsersControllerUpdateProfile$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.usersControllerUpdateProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

}
